import React from 'react';
import { useQuery } from 'react-query';

import styled from 'styled-components';

import { getRecommendations } from 'apis/RecommendationsAPI';
import Header from 'common/Header';
import ErrorMessage from 'components/lib/ErrorMessage';
import Loader from 'components/lib/Loader';
import { useAppSelector } from 'store/hook';

import RecommendationCompanyBreadcrumb from './RecommendationCompanyBreadcrumb';
import RecommendationFilters from './RecommendationFilters';
import RecommendationList from './RecommendationList';
import useRecommendationsContext from './RecommendationsContext';

const Container = styled.div`
  width: 100%;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 10px 30px;
`;

const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin-right: 10px;
  padding: 1px;
  background-image:
    linear-gradient(var(--white), var(--white)),
    linear-gradient(to bottom, var(--competitor-purple), var(--negative-orange) 50%, var(--flamingo-pink));
  background-origin: border-box;
  background-clip: content-box, border-box;
`;

const Recommendations = () => {
  const { selectedCommunity } = useAppSelector((state) => state.global);
  const { company, filters } = useRecommendationsContext();

  const { isLoading, data, isError } = useQuery({
    queryKey: ['company', company?.id, filters],
    queryFn: () =>
      getRecommendations(company?.id ?? -1, {
        communities: filters.communities,
        care_types: filters.careTypes,
        categories: filters.categories,
        show_in_ai_insights: true,
      }),
    enabled: Boolean(company?.id),
    refetchOnWindowFocus: false,
  });

  return (
    <Container>
      <Header
        title="AI Insights"
        breadcrumbs={<RecommendationCompanyBreadcrumb />}
        iconComponent={
          <IconContainer>
            <img src="/icons/ai-blob.svg" alt="ai-blob" height="30px" width="30px" />
          </IconContainer>
        }
      />
      <Main>
        <RecommendationFilters hideCommunitiesFilter={!!selectedCommunity} />
        <Loader active={isLoading} />
        <ErrorMessage text="Failed to load AI insights. Please try again." active={isError} />
        <RecommendationList data={data} />
      </Main>
    </Container>
  );
};

export default Recommendations;
